import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBrandgevaar = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      d="M24 16c4 4 4.91 9.82 1.7 13s-9 2.6-13-1.37z"
    />
    <path
      fill="#FF7842"
      d="M11.79 16.9a.61.61 0 0 1 1.09.35 5.35 5.35 0 0 0 2.54 4.15s-3.1-10.35 4.47-15.3a.48.48 0 0 1 .72.53 5.45 5.45 0 0 0 1.68 5.61c3.4 3.4 7.92 5.68 8 11.28a10.14 10.14 0 0 1-8.51 10.31A10.272 10.272 0 0 1 9.7 23.68s.1-4.13 2.09-6.78m6.31 10a7.5 7.5 0 0 1-2.56 1.28.681.681 0 0 0-.19 1.21 7.482 7.482 0 0 0 11.95-4.648 7.48 7.48 0 0 0-3.75-7.812A7.47 7.47 0 0 1 20 27.43a5 5 0 0 0 .89-5c-.72 2.36-1.43 3.4-2.79 4.43z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M20.372 11.81c0-2.174.86-4.26 2.393-5.802l.71.705a7.23 7.23 0 0 0 0 10.194l-.71.706a8.23 8.23 0 0 1-2.393-5.803M10.481 19.45a6.37 6.37 0 0 1 1.865-4.503l.708.707a5.37 5.37 0 0 0 0 7.593l-.708.706a6.37 6.37 0 0 1-1.865-4.503"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBrandgevaar);

export default ForwardRef;
